import {
  SET_ITEMS,
  SET_NA_ITEMS,
  SET_ITEMS_BY_RETURN_DATE,
  SET_ITEMS_BY_RETURN_DAY,
  SET_ITEMS_GROUPING_ITEMS,
  SET_ITEM_RETURN_QTY_BY_DAY,
  SET_RETURN_LABELS,
  SET_RETAILER_ELIGIBILITIES,
  SET_BUNDLE_ITEMS,
} from '../../actions/orderService';

export const initialState = {
  items: [],
  naItems: [],
  itemsByReturnDate: [],
  itemsByReturnDay: [],
  itemGroupingItems: [],
  bundleItems: {},
  itemReturnQtyByDay: [],
  returnLabels: [],
  retailerEligibilities: {},
  isFetchingEligibilities: false,
};

export default (
  state = initialState,
  {
    type,
    data: {
      items,
      naItems,
      itemsByReturnDate,
      itemsByReturnDay,
      itemGroupingItems,
      bundleItems,
      itemReturnQtyByDay,
      returnLabels,
      retailerEligibilities,
    } = {},
  } = {},
) => {
  switch (type) {
    case SET_ITEMS:
      return {
        ...state,
        items,
      };
    case SET_NA_ITEMS:
      return {
        ...state,
        naItems,
      };

    case SET_ITEMS_BY_RETURN_DATE:
      return {
        ...state,
        itemsByReturnDate,
      };

    case SET_ITEMS_BY_RETURN_DAY:
      return {
        ...state,
        itemsByReturnDay,
      };

    case SET_ITEMS_GROUPING_ITEMS:
      return {
        ...state,
        itemGroupingItems,
      };

    case SET_BUNDLE_ITEMS:
      return {
        ...state,
        bundleItems,
      };

    case SET_ITEM_RETURN_QTY_BY_DAY:
      return {
        ...state,
        itemReturnQtyByDay,
      };

    case SET_RETURN_LABELS:
      return {
        ...state,
        returnLabels,
      };

    case SET_RETAILER_ELIGIBILITIES:
      return {
        ...state,
        retailerEligibilities,
      };

    default:
      return state;
  }
};
